import AppImage from "./AppImage";

export default AppImage;
export type { AppImageProps } from "./AppImage";
